import { LightbulbMultipleIcon } from './LightbulbMultipleIcon';

/**
 * author: Michael Richins
 * id 33D321D2-E427-469E-9646-D5758B4D5038
 * name lightbulb-multiple
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-multiple.svg
 * tags
 * - Home Automation 
 */
export const BulbsIcon = LightbulbMultipleIcon;
export default BulbsIcon